import { makeStyles } from '@material-ui/styles'
import { ChevronRightRounded } from '@mui/icons-material'
import { Breadcrumbs, Button, Link, Stack, Typography } from '@mui/material'
import { blue, grey } from '@mui/material/colors'
import { BsFileEarmarkArrowUp, BsPlusCircleDotted } from 'react-icons/bs'
import { useSelector } from 'react-redux'
import { selectCurrrentAdminShop } from '../../../../../store/features/currentBusinessShop'
import {Link as RRDLink} from 'react-router-dom'
// import { Link } from 'react-router-dom'
interface IPageHeaderProps{
    onBtnPrimaryClick: ()=>void
    onBtnSecondaryClick: ()=>void
}

export default function PageHeader({onBtnPrimaryClick, onBtnSecondaryClick}:IPageHeaderProps) {

    const classes = useStyles()
    const currentShop = useSelector(selectCurrrentAdminShop)

    return(

        <Stack direction="row" justifyContent="space-between" alignItems="center" >
                    
            <Stack direction="column">
                <Typography variant="h6" sx={{color: "grey.200", fontWeight: "bold" }}>Product Categories</Typography>
                <Breadcrumbs sx={{color: grey[500] }} separator={<ChevronRightRounded sx={{color: grey[500]}} />}  >
                    <Link to={`/${currentShop?.name}`} className={classes.links} component={RRDLink} >
                        {currentShop?.name}
                    </Link>
                    <Link to="" className={classes.link_current} component={RRDLink} >
                        Product categories
                    </Link>
                </Breadcrumbs>
            </Stack>

            <Stack direction="row" spacing={2}>
                <Button onClick={onBtnPrimaryClick} className={classes.button__primary} variant="contained" title="New items to inventory" startIcon={<BsPlusCircleDotted />} >
                    Add
                </Button>
                <Button onClick={onBtnSecondaryClick} className={classes.button__secondary} variant="contained" title="Export to excel sheet" startIcon={<BsFileEarmarkArrowUp />} >
                    Export
                </Button>
            </Stack>
        </Stack>

    )
}

const useStyles= makeStyles(theme=>({

    button__primary:{
        color: grey[200],
        boxShadow: "none",
        backgroundColor: blue[700],
        textTransform: "capitalize",
        '&:hover': {
            backgroundColor: blue[700]
        },
        border: `.5px solid rgba(255, 255, 255, 0.1)`,
    },
    button__secondary:{
        color: '#1A1B41',
        boxShadow: "none",
        backgroundColor: '#baff29',
        textTransform: "capitalize",
        '&:hover': {
            backgroundColor: '#baff29'
        },
        border: `.5px solid rgba(255, 255, 255, 0.1)`,
    },
    links:{
        color: grey[200],
        textDecoration: "none",
        fontSize: "13px"
    },
    link_current:{
        color: grey[500],
        textDecoration: "none",
        fontSize: "13px"
    }

}))
